// extracted by mini-css-extract-plugin
module.exports = {"cls1":"index-MastHead-module--cls1--37xum","cls2":"index-MastHead-module--cls2--OdHF- index-MastHead-module--cls1--37xum"};